angular.module('impactx.condition').controller('DimensionConditionDetailController', DimensionConditionDetailController);
DimensionConditionDetailController.$inject = [
    '$scope',
    'dataGen',
    'BackService',
    '$mdToast',
    'ConfirmationService',
    '$routeParams',
    '$locale',
    'ToolbarService'
];

function DimensionConditionDetailController($scope, dataGen, BackService, $mdToast, ConfirmationService, $routeParams, $locale, ToolbarService) {
    var ctrl = this;

    dataGen.getData($scope, {id: $routeParams.id}, "/condition/viewDimension").then(function () {
        defineButtons();
    });

    ctrl.save = function () {
        prepareForSave();
        var dataObj = {
            data: $scope.data
        };
        return dataGen.postAsForm($scope, dataObj, "/condition/save").then(function () {
            BackService.back();
            $mdToast.show(
                $mdToast.simple()
                    .textContent($scope.trns.saveSuccess)
                    .position("bottom right")
                    .hideDelay(10000)
            );
        });
    };

    var prepareForSave = function () {
        if ($scope.data.dimensionCondition.selected.id === 4) {
            $scope.data.relativeGroup.setId = 1;
        }
    };

    ctrl.getExampleArray = function () {
        var resultArray = [];
        var result = "";
        var minVal1 = impactX.isDefined($scope, "data.minimumAmountOrValue.value");
        var minVal2 = impactX.isDefined($scope, "data.minimumAmountOrValue2.value");
        if (minVal1) {
            for (var i = 1; i < 4; i++) {
                var formatted1 = formatVal(i * minVal1);
                if (resultArray.indexOf(formatted1) === -1) {
                    resultArray.push(formatted1);
                    result = result + formatted1 + ", ";
                }
                if (minVal2) {
                    for (var j = 1; j <= i; j++) {
                        var formatted2 = formatVal(i * minVal1 + j * minVal2);
                        if (resultArray.indexOf(formatted2) === -1) {
                            resultArray.push(formatted2);
                            result = result + formatted2 + ", ";
                        }
                    }
                }
            }
            result = result + "etc.";
        }
        return result;
    };

    ctrl.recalcDiscount = function () {
        var relative = $scope.data.relativeGroup.setId;
        if (relative == 1) { // relative
            $scope.data.discountRate.value = $scope.data.discountOrCost.value / 100;
            $scope.data.discountOrCost2.value = $scope.data.discountOrCost2.value / 100;
            $scope.data.discountOrCost3.value = $scope.data.discountOrCost3.value / 100;
            $scope.data.discountOrCost.value = null;
        }
        else if (relative == 3) { // absolute
            $scope.data.discountOrCost.value = $scope.data.discountRate.value * 100;
            $scope.data.discountOrCost2.value = $scope.data.discountOrCost2.value * 100;
            $scope.data.discountOrCost3.value = $scope.data.discountOrCost3.value * 100;
            $scope.data.discountRate.value = null;
        }
        else { // should not happen, reset
            $scope.data.discountRate.value = null;
            $scope.data.discountOrCost.value = null;
            $scope.data.discountOrCost2.value = null;
            $scope.data.discountOrCost3.value = null;
        }
    };

    ctrl.deleteDialog = function (event) {
        ConfirmationService.showConfirmationDialog(ctrl.delete, event, $scope.trns.confirmDelete,
            $scope.trns.delete, $scope.trns.abort);
    };

    ctrl.delete = function () {
        var dataObj = {
            id: $scope.data.id
        };
        dataGen.getData($scope, dataObj, "/condition/delete").then(function () {
            BackService.back();
            $mdToast.show(
                $mdToast.simple()
                    .textContent($scope.trns.deleteSuccess)
                    .position("bottom right")
                    .hideDelay(10000)
            );
        });
    };

    var formatVal = function (val) {
        var formats = $locale.NUMBER_FORMATS;
        var maxFrac = 11 - Math.floor(Math.log(val) / Math.log(10));
        var unit = $scope.data.units[$scope.data.dimensionType.selected.id];
        var pattern =
            {
                "gSize": 3,
                "lgSize": 3,
                "maxFrac": maxFrac,
                "minFrac": 0,
                "negPre": "-",
                "negSuf": "",
                "posPre": "",
                "posSuf": unit || ""
            };
        return formatNumber(val, pattern, formats.GROUP_SEP, formats.DECIMAL_SEP, undefined);
    };

    $scope.filterPolicy = function (policy) {
        switch (policy.value) {
            case 0:
                //always, that's easy
                return true;
            case 1:
                //only for pos related conditions
                return $scope.data.posRelatedGroup.setId == 0;
            case 2:
            case 6:
                //filtered by backend
                return true;
            case 7:
            case 9:
            case 10:
                //only for not pos related conditions
                return $scope.data.posRelatedGroup.setId == 1;
            default:
                return false;
        }
    };

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.save,
                action: ctrl.save,
                type: 'validation',
                condition: isEditable,
                params: {
                    form: $scope.dialogData
                }
            },
            {
                label: $scope.trns.delete,
                action: ctrl.deleteDialog,
                type: 'dialogaction',
                condition: canDelete
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }

    function isEditable() {
        return !$scope.data.readOnly;
    }

    function canDelete() {
        return !$scope.data.readOnly && $scope.data.id > 0
    }
}